import { AC_STEP_CONFIRM_AGE, AC_STEP_PARENT_EMAIL } from "../../utils/AccountCreationConstants";

import useAccountCreationData from "../../../../../../state/landingPages/accountCreation/UseAccountCreationData";

const useAccountCreationYouthWarning = () => {
  const { updateAccountCreationStep } = useAccountCreationData();

  const onContinueClicked = () => {
    updateAccountCreationStep(AC_STEP_PARENT_EMAIL);
  };

  const onBackClicked = () => {
    updateAccountCreationStep(AC_STEP_CONFIRM_AGE);
  };

  return {
    onContinueClicked,
    onBackClicked
  };
};

export default useAccountCreationYouthWarning;